import React from "react";
import Checkbox from "@material-ui/core/Checkbox";
import {
  ConsentModel,
  AdditionalConsentsId,
  RequiredConsentsId
} from "../../../../helpers/consents";
import { inject, observer } from "mobx-react";
import { ProposalStore } from "../../../../stores/proposalStore";
import { PolicyStore } from "../../../../stores/policyStore";
import Notification from "../../../sharedComponents/notification/notification";
import { FormControlLabel } from "@material-ui/core";

interface ConsentProps {
  consentId: RequiredConsentsId | AdditionalConsentsId;
  proposalStore?: ProposalStore;
  policyStore?: PolicyStore;
  consent: ConsentModel;
  onChange?: (value: boolean) => void;
}

export function Consent(props: ConsentProps) {
  return (
    <div className={`consent ${props.consentId}`}>
      <FormControlLabel
        control={
          <Checkbox
            checked={props.proposalStore!.consents[props.consentId].value}
            onChange={(event) => {
              props.proposalStore!.setConsent(props.consentId, event.target.checked);
            }}
            disableRipple
            className={`${props.proposalStore!.consents[props.consentId].error ? "consents-error" : ""}`}
          />
        }
        label={
          <>
            {props.consent.required && <span className="require-field">*</span>}
            <div>
              {props.consent.description}
              {props.proposalStore!.consents[props.consentId].error && (
                <Notification type="error" message="Zgoda wymagana" />
              )}
            </div>
          </>
        }
      />
    </div>
  );
}

export default inject("proposalStore", "policyStore")(observer(Consent));
